import React, { useState } from 'react';
import { Dialog, Paper, CircularProgress, Typography, Button, withStyles } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone'
import { connect } from "react-redux";
import * as actions from "./store/translateActions";
import { BackButton, capitalize } from '../../sc-utilities';
import History from "../../../History";

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiDialogContent-root']": {
            overflowX: 'hidden',
            flex: ' 1 1 auto',
            padding: '8px 24px'
        },
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        marginTop: "10px"
    },
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    dialog: {
        width: 'auto',
        overflow: 'hidden'
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    progress: {
        width: `398px`,
        height: "400px"
    },
    typographyTo: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
    },
    typography: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
        position: "absolute",
        top: "40%",
        right: "0",
        textAlign: "center",
        left: "0"
    }
});

const TranslationUpload = props => {
    let { classes, translations, translation, activeCustomer } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '', buttonDisabled: true, open: false });
    const handleSubmit = async event => {
        event.preventDefault();
        if (!fileToSend.fileName || !fileToSend.fileName.includes('.xlsx') || !fileToSend.fileName.includes('.xls')) {
            return props.sendMessage(translations['chose_xlsx'] || 'Please choose xlsx file', 'warning')
        }
        setFileToSend({ ...fileToSend, buttonDisabled: true });
        const data = new FormData();
        data.append('File', fileToSend.fileToSend);
        data.append('ActiveCustomerID', activeCustomer);
        let token = localStorage.getItem('SESSION');

        data.append('Token', token);
        let res = await props.uploadTranslations(data);
        if (res) {
            History.goBack()
        }
    }

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ ...fileToSend, fileToSend: {}, fileName: '', buttonDisabled: true });
            return
        }
        setFileToSend({ ...fileToSend, fileToSend: file, fileName: file.name, buttonDisabled: false });
    }

    return (<>
        <Paper className={classes.root} >
            {BackButton(translations)}

            <Typography>
                {translations['supported_format'] || 'Supported format'}{' .XLSX '}.<br />
            </Typography>
            <form >
                <DropzoneArea
                    filesLimit={1}
                    maxFileSize={5368709120}
                    getFileRemovedMessage={(fileName) => {
                        const text = translations ? (
                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                        ) : `File ${fileName} removed.`

                        return text;
                    }}
                    getFileAddedMessage={(fileName) => {
                        const text = translations ? (
                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                        ) : `File ${fileName} successfully added.`

                        return text;
                    }}
                    getFileLimitExceedMessage={(filesLimit) => {
                        const text = translations ? (
                            capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                        ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`

                        return text;
                    }}
                    getDropRejectMessage={(rejectedFile) => {
                        const text = translations ? (
                            capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                        ) : `File was rejected.`

                        return text;
                    }}
                    dropzoneText={`${translations['drag_and_drop_an'] || 'Drag and drop an'} .xlsx ${translations['file_here'] || 'file here or click'}`}
                    onChange={handleUpload}
                    acceptedFiles={['.xlsx', '.xls']}
                />
                <Button
                    className={classes.submit}
                    variant="contained"
                    type="submit"
                    onClick={handleSubmit}
                    fullWidth={true}
                    disabled={fileToSend.buttonDisabled}
                >
                    {translations['import'] || "Import"}
                </Button>
            </form>
        </Paper>
        <Dialog
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            open={translation.snackStart ? true : false}
            PaperProps={{
                classes: {
                    root: classes.paper
                }
            }}
        >
            <div style={{ marginBottom: "1px", position: "relative" }}>
                <CircularProgress
                    variant="static"
                    color="primary"
                    style={{ marginBottom: "10px" }}
                    size={300}
                    value={translation.progress ? translation.progress : 0}
                />
                <Typography
                    className={classes.typography}
                    variant="h4"
                >
                    {" "}
                    {translation.progress && translation.progress > 100 ? 100 : translation.progress ? translation.progress : 0}%{" "}                    </Typography>
                <br></br>
            </div>
            {translation.progress === 100 || translation.progress > 100 ? <Typography variant="h5" className={classes.typographyTo}
            >
                {translations['file_upload'] || 'File upload finished'}    <br />
                {translations['import_progress'] || 'Import in progress'}
            </Typography>
                : <Typography variant="h5" className={classes.typographyTo}
                >{translations['please_do_not'] || 'Please do not refresh THIS page'}
                </Typography>
            }
        </Dialog>
    </>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translation: state.translate.translations,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadTranslation: filterParams => dispatch(actions.loadTranslation(filterParams)),
        editTranslation: data => dispatch(actions.editTranslations(data)),
        uploadTranslations: data => dispatch(actions.uploadTranslations(data)),

    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TranslationUpload));